import {InjectionToken} from '@angular/core';
import {AadB2CHelper} from 'src/app/helpers/AadB2CHelper';

export const AADB2C_HELPER = new InjectionToken<AadB2CHelper>('aadB2C.helper');

const aadB2CHelperFactory = () => {
    return new AadB2CHelper();
};

export let AadB2CHelperProvider = {
    provide: AADB2C_HELPER,
    useFactory: aadB2CHelperFactory
};
